import { call, put, takeEvery } from 'redux-saga/effects';
import { ADD_GROUP_REQUEST } from '../constants/add_group.constants';
import { addGroup } from '../../requests/add_group_request';
import { addGroupFailure } from '../actions/add_group.actions';
// import { history } from '../../../../../config/history';
import { message_error, message_success } from '../../../../../components/Message';

function* addGroupSaga({ params }) {
    const { result, msg, error } = yield call(addGroup, params);
    if (result) {
        // history.push('/UserManagement/User_group/');
        message_success('Group created successfully!');
    } else {
        yield put(addGroupFailure(msg));
        error.code === 11000
            ? message_error('Group with name is already exist')
            : message_error(msg);
    }
}

export default function* addUserSaga() {
    yield takeEvery(ADD_GROUP_REQUEST, addGroupSaga);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/redux/sagas/add_group.saga.js